<template>
  <!--帮助中心-->
  <div class="container col-jj">
    <!--橙联介绍 Orange Connex-->
    <div class="intro about01_mod">
      <div class="container">
        <div class="col-md-12 intro_text" >
          <h4>{{$t('about.OrangeConnex')}}</h4>
          <p>{{$t('about.OClimitedt')}}<br/>{{$t('about.OClimitedv')}}</p>
        </div>
      </div>
    </div>
    <!--橙联介绍 Orange Connex../-->

  </div>
  <!--帮助中心../-->
</template>

<script>
    export default {
        name: "about01"
    }
</script>





// WEBPACK FOOTER //
// about01.vue?634d9174